import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { DialogActions, DialogContentText, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { Control } from '@features/effector-form';
import { $savedFilters, filterNameForm, SaveFiltersGate } from '../../model';
import * as Styled from './styled';

export const SaveDialog = ({
  dialogVisible,
  setDialogVisible,
}: {
  dialogVisible: boolean;
  setDialogVisible: Dispatch<SetStateAction<boolean>>;
}) => {
  const [isOverWrire, setIsOverWrire] = useState(false);

  const setDialogVisibleDec = (status: boolean) => {
    setDialogVisible(status);
    setIsOverWrire(false);
  };

  if (!dialogVisible) return null;

  return (
    <>
      <SaveFiltersGate />

      <Dialog onClose={() => setDialogVisibleDec(false)} open>
        {isOverWrire ? (
          <SaveDialogOverWrite
            dialogVisible={dialogVisible}
            setDialogVisible={setDialogVisibleDec}
            setIsOverWrire={setIsOverWrire}
          />
        ) : (
          <SaveDialogGeneral
            dialogVisible={dialogVisible}
            setDialogVisible={setDialogVisibleDec}
            setIsOverWrire={setIsOverWrire}
          />
        )}
      </Dialog>
    </>
  );
};

export const SaveDialogOverWrite = ({
  dialogVisible,
  setDialogVisible,
  setIsOverWrire,
}: {
  dialogVisible: boolean;
  setDialogVisible: (status: boolean) => void;
  setIsOverWrire: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();
  const { submit } = useUnit(filterNameForm);

  const saveFilter = () => {
    submit();
    setDialogVisible(false);
    setIsOverWrire(false);
  };

  if (!dialogVisible) return null;

  return (
    <>
      <DialogTitle>{t('OverwritingFilter')}</DialogTitle>

      <Styled.DialogContent>
        <DialogContentText>
          <Typography variant="body1">{t('filterAlreadyExists')}</Typography>
        </DialogContentText>
      </Styled.DialogContent>

      <DialogActions>
        <Button onClick={saveFilter} variant="contained">
          {t('Overwrite')}
        </Button>

        <Button onClick={() => setIsOverWrire(false)} variant="outlined">
          {t('cancel')}
        </Button>
      </DialogActions>
    </>
  );
};

export const SaveDialogGeneral = ({
  dialogVisible,
  setDialogVisible,
  setIsOverWrire,
}: {
  dialogVisible: boolean;
  setDialogVisible: (status: boolean) => void;
  setIsOverWrire: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  const [savedFilters] = useUnit([$savedFilters]);
  const { submit, values } = useUnit(filterNameForm);

  const saveFilter = () => {
    const isFilterNameExists = savedFilters.find(
      ({ name }) => name === values.filterName
    );

    if (isFilterNameExists) {
      setIsOverWrire(true);

      return;
    }

    submit();
    setDialogVisible(false);
  };

  useEffect(() => {
    document.getElementById('ticketsfilterName')?.focus();
  }, []);

  if (!dialogVisible) return null;

  return (
    <>
      <DialogTitle>{t('SavingFilter')}</DialogTitle>

      <Styled.DialogContent>
        <DialogContentText>
          <Typography variant="body1">{t('SavingFilterText')}</Typography>
        </DialogContentText>

        <Control.Text
          id="ticketsfilterName"
          form={filterNameForm}
          name="filterName"
          label={t('NameTitle') as string}
          required
        />
      </Styled.DialogContent>

      <DialogActions>
        <Button
          onClick={saveFilter}
          variant="contained"
          disabled={!values.filterName.length}
        >
          {t('Save')}
        </Button>

        <Button onClick={() => setDialogVisible(false)} variant="outlined">
          {t('cancel')}
        </Button>
      </DialogActions>
    </>
  );
};
